import { Divider, Grid, IconButton, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../../../controls";
import { Model, UseForm } from "../../../../hooks";
import { Alert, Form, Tabs } from "../../../../layout";
import { ArrowBackRounded } from "@mui/icons-material";
import { AppContext } from "../../../../App";
import { API, action, controller } from "../../../../api/api";
import { BGNestedObjToFromData, RmvEmptyProp } from "../../../../hooks/Method";
import GeneralFields from "./GeneralFields";
import AccessAndPermissions from "./AccessAndPermissions";
import AdditionalFields from "pages/Customer/CustomerForm/AdditionalFields";

const AddEditUser = (props) => {
  const { fromMyAcc = false } = props;
  const { id } = useParams();
  const { UserMdl } = Model();
  const { authUser } = useContext(AppContext);
  const navigate = useNavigate();
  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    setValues,
    handleFile,
    handleInpDate,
    handleInpPass,
    passValid,
  } = UseForm(UserMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    id &&
      API(controller.User + action.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = RmvEmptyProp(res.result);
          setValues((x) => ({
            ...x,
            ...val,
            outletPermissions:
              val.outletPermissions && val.outletPermissions.length > 0
                ? val.outletPermissions.map((o) => o.outletId)
                : [],
          }));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const validateForm = () => {
    let temp = {};
    temp.fullName = values.fullName !== "" ? "" : "Full name is required.";
    temp.email = values.email !== "" ? "" : "Email is required.";
    temp.phone = values.phone !== "" ? "" : "Phone is required.";
    temp.username =
      values.username !== ""
        ? errors.username
          ? errors.username
          : ""
        : "Username is required.";

    temp.outletPermissions =
      values.outletPermissions.length > 0 ? "" : "Outlet is required.";
    temp.roleId = values.roleId !== "" ? "" : "Role is required.";
    // Password Property required only account creating time.
    if (!id && values.role !== 4) {
      temp.password = values.password !== "" ? "" : "Password is required";
      temp.confirmPass =
        values.confirmPass !== ""
          ? values.confirmPass === values.password
            ? ""
            : "Password and confirm password not match"
          : "Confirm password is reqquired";
    }
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Success",
              subTitle: `User ${id ? "Updated" : "Added"} Successfully.`,
              onClick: () => !fromMyAcc && navigate("/users"),
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: "Error",
              subTitle: res.msg,
            });
        }
      };
      if (values.id === 0) {
        values.orgId = authUser.orgId;
        API(controller.User + action.Post).post(
          BGNestedObjToFromData(
            RmvEmptyProp({
              ...values,
              outletPermissions: values.outletPermissions.map((j) => ({
                outletId: j,
                createDate: new Date().toISOString(),
              })),
            })
          ),
          onComplete
        );
      } else {
        API(controller.User + action.Put).put(
          BGNestedObjToFromData(
            RmvEmptyProp({
              ...values,
              outletPermissions: values.outletPermissions.map((j) => ({
                outletId: j,
              })),
              updateDate: new Date().toISOString(),
            })
          ),
          onComplete
        );
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-[10px] flex justify-between items-center pt-[8px] pl-[8px] pr-[8px]">
            <div className="flex items-center gap-[10px]">
              <div>
                <IconButton
                  size="small"
                  className="p-0"
                  onClick={() => navigate(-1)}
                >
                  <ArrowBackRounded />
                </IconButton>
              </div>
              <div>
                <h1 className="text-[18px] font-medium text-gray-500 uppercase">
                  {fromMyAcc ? "My Account" : id ? "Edit User" : "Add User"}
                </h1>
              </div>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? "Save Changes" : "Submit"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-[15px] pr-[15px] pb-[15px]">
            <Tabs
              className="mt-[30px]"
              header={[
                { label: "General Fields", icon: "" },
                { label: "Additional Fields", icon: "" },
              ]}
            >
              {/* ============ General Fields and Access ============ */}
              <Grid container spacing={2.5}>
                <GeneralFields
                  {...{
                    values,
                    errors,
                    fromMyAcc,
                    handleInpChg,
                  }}
                />
                <AccessAndPermissions
                  {...{
                    values,
                    errors,
                    setErrors,
                    passValid,
                    fromMyAcc,
                    handleInpChg,
                    handleInpPass,
                  }}
                />
              </Grid>

              {/* ============ Additional Fields ============ */}
              <AdditionalFields
                {...{
                  values,
                  setValues,
                  errors,
                  handleFile,
                  handleInpChg,
                  handleInpDate,
                }}
              />
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditUser;
